import React from 'react'
import { Container, Row } from 'react-bootstrap';
import { plantSlider } from '../../data/localData';
import Carousel from 'react-bootstrap/Carousel';

function PlantSlider() {

    return (
        <div className='web-gallery'>
            <Container>
                <div className='flex-center-align py-4 pt-5 '>
                    <h1 className='m-0 page-title text-center text-center fs-md-35 fs-sm-25 fw-semibold'>
                        Plant <span>&</span> Production Gallery
                    </h1>
                </div>
                <Row>
                    <Carousel fade indicators={false} interval={null} className='main-holder'>
                        {
                            plantSlider.map((image, index) => {
                                return (
                                    <Carousel.Item key={index} className=''>
                                        <div className='image-holder'>
                                            <img src={image} alt="" />
                                        </div>
                                        {/* <Carousel.Caption>
                                            <h3>First slide label</h3>
                                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                        </Carousel.Caption> */}
                                    </Carousel.Item>
                                )
                            })
                        }
                    </Carousel>
                </Row>

            </Container>
        </div>
    )
}

export default PlantSlider